import React from 'react';
import { Dialog, DialogBody } from '@sendsprint/ui-react/dist/components/Dialog';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import Text from '@sendsprint/ui-react/dist/components/Text';
import triangleSuccessErrorImg from '@src/assets/images/triangle-success-error.png';
import Image from '@src/components/image';
import { useToggle } from '@src/hooks';

const UpdateBusinessAddress = () => {
  const { handleTrue: handleModalOpen, handleFalse: handleModalClose, state: isOpen } = useToggle();

  return (
    <Dialog isOpen={isOpen} onDismiss={handleModalClose}>
      <DialogBody>
        <Box className="ss-flex ss-px-6 ss-flex-col ss-items-center ss-text-center">
          <Image alt="" src={triangleSuccessErrorImg} className="ss-w-[100px] ss-h-[100px]" />
          <Text variant="h6" className="ss-mt-4 ss-mb-2">
            Update Business Address
          </Text>
          <Text className="ss-mb-8">
            Upload a valid document to update your business address and remove account restrictions.
          </Text>
          <Box className="ss-w-full">
            <Button isBlock label="Update Address" />
          </Box>
        </Box>
      </DialogBody>
    </Dialog>
  );
};

export default UpdateBusinessAddress;
